import { AccordionDetails } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
  root: {
    padding: 0,
  },
});

export default withStyles(AccordionDetails, styles);
